// assets/uploadcare-line-item.js
(function () {
  function styleButtons(scope) {
    scope.querySelectorAll(
      '.uploadcare--widget__button,' +
      '.uploadcare--widget__button_type_open,' +
      '.uploadcare--widget__button_primary'
    ).forEach(function (btn) {
      btn.style.backgroundColor = '#ed2224';
      btn.style.color = '#fff';
      btn.style.border = 'none';
      btn.style.borderRadius = '8px';
      btn.style.fontWeight = '700';
      btn.style.padding = '10px 16px';
      btn.style.cursor = 'pointer';
    });
  }

  function hideClutter(block) {
    block.querySelectorAll(
      '.uploadcare--widget__file-name,' +
      '.uploadcare--widget__file-size,' +
      '.uploadcare--widget__text,' +
      '.uploadcare--widget__files'
    ).forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function updateHidden(hidden, url) {
    hidden.value = url || '';
    hidden.setAttribute('value', url || '');
    hidden.dispatchEvent(new Event('input', { bubbles: true }));
    hidden.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function extractUuid(value) {
    if (!value) return '';
    const match = String(value).match(/([a-f0-9-]{36})/i);
    return match ? match[1] : '';
  }

  function getFinalUrl(fileInfo) {
    if (!fileInfo) return '';

    // Use Uploadcare's own final CDN URL exactly as returned.
    let url = fileInfo.cdnUrl || fileInfo.originalUrl || '';

    // Fallback only if Uploadcare does not provide a URL
    if (!url) {
      const uuid =
        fileInfo.uuid ||
        extractUuid(fileInfo.cdnUrl || fileInfo.originalUrl || '');

      if (uuid) {
        // Fallback to the legacy global domain only when needed.
        url = `https://ucarecdn.com/${uuid}/`;
      }
    }

    return url;
  }

  function createPreview(block, url, name) {
    let wrap = block.querySelector('[data-uploadcare-preview]');

    if (!url) {
      if (wrap) wrap.remove();
      return;
    }

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.setAttribute('data-uploadcare-preview', 'true');
      wrap.style.marginTop = '10px';
      wrap.style.display = 'flex';
      wrap.style.gap = '10px';
      wrap.style.alignItems = 'center';

      const img = document.createElement('img');
      img.style.width = '56px';
      img.style.height = '56px';
      img.style.objectFit = 'cover';
      img.style.borderRadius = '6px';
      img.style.border = '1px solid #ddd';

      const text = document.createElement('div');

      const nameEl = document.createElement('div');
      nameEl.style.fontSize = '14px';

      const link = document.createElement('a');
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.style.fontSize = '13px';

      text.appendChild(nameEl);
      text.appendChild(link);
      wrap.appendChild(img);
      wrap.appendChild(text);
      block.appendChild(wrap);
    }

    const uuid = extractUuid(url);

    wrap.querySelector('img').src = uuid
      ? `https://ucarecdn.com/${uuid}/-/preview/120x120/`
      : '';

    wrap.querySelector('div div').textContent = name || 'Uploaded file';
    wrap.querySelector('a').href = url;
    wrap.querySelector('a').textContent = 'Open file';
  }

  function bindUploader(el) {
    if (!window.uploadcare) return;
    if (el.dataset.ucBound === '1') return;
    el.dataset.ucBound = '1';

    el.setAttribute('data-public-key', window.UPLOADCARE_PUBLIC_KEY);
    el.setAttribute('data-multiple', 'false');
    el.setAttribute('data-store', '1');

    const block = el.closest('[data-uploadcare-block]') || el.parentElement;
    const hidden = document.querySelector(el.getAttribute('data-target-hidden'));
    const status = document.querySelector(el.getAttribute('data-target-status'));

    if (!hidden) return;

    const widget = uploadcare.Widget(el);

    widget.onChange(function (file) {
      if (!file) {
        updateHidden(hidden, '');
        createPreview(block, '', '');
        if (status) status.textContent = '';
      } else {
        if (status) status.textContent = 'Uploading...';
      }
    });

    widget.onUploadComplete(function () {
      const value = widget.value();

      if (!value || typeof value.done !== 'function') {
        updateHidden(hidden, '');
        if (status) status.textContent = 'Upload failed';
        return;
      }

      value.done(function (fileInfo) {
        if (!fileInfo) return;

        const finalUrl = getFinalUrl(fileInfo);
        const fileName = fileInfo.originalFilename || fileInfo.name || '';

        updateHidden(hidden, finalUrl);

        if (status) status.textContent = '';
        createPreview(block, finalUrl, fileName);

        console.log('Uploadcare fileInfo:', fileInfo);
        console.log('Saved Uploadcare URL:', finalUrl);
      });

      if (typeof value.fail === 'function') {
        value.fail(function () {
          updateHidden(hidden, '');
          if (status) status.textContent = 'Upload failed';
        });
      }
    });

    setTimeout(function () {
      styleButtons(block);
      hideClutter(block);
    }, 0);

    new MutationObserver(function () {
      styleButtons(block);
      hideClutter(block);
    }).observe(block, { childList: true, subtree: true });
  }

  function init() {
    if (!window.uploadcare) return;
    document.querySelectorAll('[data-uc-uploader]').forEach(bindUploader);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();